<template>
<div>
    <div  :class="{sumarioTo:true,aparecerSu:aparecerSu}">
    <div :class="{suma:true,sumarioNone:sumarioNone}" style="width:385px;right:0px;font-size:11px;top:-240px;">
        <p><a href="#a0">1. Fundamentos da LGPD</a></p>
                <p> <a href="#a1">2. Aplicabilidade</a></p>
                <p><a href="#a2">3. Conceitos</a></p>
                <p><a href="#a3">4. Princípios que Devem ser Adotados</a></p>
                <p><a href="#a4">5. Hipóteses de Tratamento de Dados</a></p>
                <p><a href="#a5">6. Direitos do Titular de Dados</a></p>
                <p><a href="#a6">7. Sanções Administrativas</a></p>
                <p><a href="#a7">8. Autoridade Nacional de Proteção de Dados (ANPD)</a></p>
                <p><a href="#a8">9. Conselho Nacional de Proteção de Dados Pessoais e da Privacidade</a></p>
    </div>
    <div class="suma2" @click="sumarioNone = !sumarioNone">
        <img src="/sandboxfront/img/setaS.svg" alt=""> Sumario<img src="/sandboxfront/img/setaS.svg" alt="">
   </div>
</div>
    <div style="display: flex;justify-content: center; flex-direction: column; align-items: center;">
          <div :class="{'opcoes-sumario':true, 'opcoes-sumario-h':opSuH}">
              <div class="sumariosP">
                <p><a href="#a0">1. Fundamentos da LGPD</a></p>
                <p> <a href="#a1">2. Aplicabilidade</a></p>
                <p><a href="#a2">3. Conceitos</a></p>
                <p><a href="#a3">4. Princípios que Devem ser Adotados</a></p>
                <p><a href="#a4">5. Hipóteses de Tratamento de Dados</a></p>
                <p><a href="#a5">6. Direitos do Titular de Dados</a></p>
                <p><a href="#a6">7. Sanções Administrativas</a></p>
                <p><a href="#a7">8. Autoridade Nacional de Proteção de Dados (ANPD)</a></p>
                <p><a href="#a8">9. Conselho Nacional de Proteção de Dados Pessoais e da Privacidade</a></p>
              </div>              
               <div class="sumario" @click="abrirOpSumario()">
                <img src="/sandboxfront/img/setaS.svg" alt="">
                <span>Sumario</span>
               <img src="/sandboxfront/img/setaS.svg" alt="">
          </div>
          </div>
      </div> 
      <div class="conteudo" style="text-align: justify;">
        <div v-for="(n,i) in arrayVisao" :key="i" style="border-bottom: 1px solid #6A6A6A;    margin-top: 25px;">
            <p style="font-weight:bold;" :id="'a'+i">{{1+i}}. {{n.titulo}}</p>
            <div v-html="n.conteudo" class="ajustarLi">

            </div>
        </div>            
      </div>
</div>
  
</template>

<script>
import calculo from '../services/calculo'
export default {
    data(){
        return{
            opSuH:false,
            arrayVisao:[],
             sumarioNone:true,
             aparecerSu:true
        }
    },
    methods:{
        abrirOpSumario(){
            this.opSuH = !this.opSuH
        },
        async getConteudo(){
            let result = await calculo.Apresentacao()
            this.arrayVisao = result.data
        }
    },
    async mounted(){
         document.addEventListener('scroll', () =>
        {
           if(window.pageYOffset>=500){
               this.aparecerSu = false
           }else{
               this.aparecerSu = true
           }
            });
        await this.getConteudo()
    }
}
</script>

<style>
.aparecerSu{
    display: none;
}
.ajustarLi ul{
    padding-left: 19px;
    text-align: justify;
}
.sumariosP{
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: justify;
    padding-bottom: 16px;
}
.sumariosP p{
    color:#4A154B;
    text-align: center;
    border-bottom: 1px solid #4A154B;
    font-weight: bold;
    margin-bottom: 0px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-align: justify;
   }
.sumariosP p:last-child{
    border:none;
}
.opcoes-sumario-h{
    min-height: 200px !important;
    border: 1px solid #4A154B;
    height: 100%  !important;
}
.opcoes-sumario-h p{  
    opacity: 1 !important;
    display: flex;
}
.opcoes-sumario p{  
    opacity: 0;
   display: none;
}
.opcoes-sumario{  
    width: 100%;
    max-width: 700px;
    margin: 30px auto;
    display: flex;
    justify-content: center;
    height: 0px;
    position: relative;
     border-radius: 10px;
    margin-bottom: 40px;
    min-height: 0px;
    
}
.sumario{
    position: absolute;
    bottom: -14px;
    background: #4A154B;
    border-radius: 0px 0px 10px 10px;
    width: 142px;
    color: #fff;
    width: 100%;
    max-width: 430px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    border-radius: 10px;
    font-weight: 600;
    padding:0px 10px;
    cursor: pointer;
    margin-top:20px;
}
</style>